import { Button, Typography } from "antd";
import styles from "./styles.module.scss";

const { Title, Text } = Typography;

interface ProcessingNoticeProps {
  onReload?: () => void;
  isReloading: boolean;
}

export function ProcessingNotice({
  onReload,
  isReloading,
}: ProcessingNoticeProps) {
  return (
    <div className={styles.processingNotice}>
      <Title
        level={5}
        style={{ marginBottom: 12, fontWeight: 700, color: "#7F7F7F" }}
      >
        Data is being processed and may take up to 20 minutes to load.
      </Title>
      <Text style={{ color: "#7F7F7F", fontSize: 12 }}>
        We calculate only the most relevant and industry-leading data, to ensure
        the right metrics are used for selecting influencers.{" "}
        <a
          // href="https://your-learn-more-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn More
        </a>
      </Text>
      <div style={{ marginTop: 24 }}>
        <Button type="primary" onClick={onReload} loading={isReloading}>
          Reload
        </Button>
      </div>
    </div>
  );
}
